import React from 'react';
import { OpportunityItem } from '../models/opportunity';

interface MetricsBarProps {
  opportunities: OpportunityItem[];
}

const isSlaCritical = (dateString?: string) => {
  if (!dateString) return false;
  return (new Date(dateString).getTime() - Date.now()) / 3600000 <= 48;
};

export const MetricsBar: React.FC<MetricsBarProps> = ({ opportunities }) => {
  const pendentes = opportunities.filter(o =>
    o.statusOportunidade === '2. Viabilidade Técnica Pendente' &&
    o.statusTecnico !== 'Parecer Técnico Concluído'
  ).length;
  const criticos = opportunities.filter(o => isSlaCritical(o.dataLimiteParecer) && o.statusTecnico !== 'Parecer Técnico Concluído').length;
  const ganhas = opportunities.filter(o => o.statusOportunidade === '5. Ganho / Aceite').length;

  const metrics = [
    { icon: '🚨', val: pendentes, lbl: 'Pendentes DTI',     color: '#CC2936' },
    { icon: '⏱️', val: criticos,  lbl: 'SLA Crítico (<48h)', color: '#F59E0B' },
    { icon: '📋', val: opportunities.length, lbl: 'Total Oportunidades', color: '#1755B8' },
    { icon: '✅', val: ganhas,    lbl: 'Ganhas',             color: '#22C55E' },
  ];

  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12,
      padding: '14px 24px', background: 'var(--chk-navy)', borderBottom: '1px solid var(--chk-border)',
    }}>
      {metrics.map((m, i) => (
        <div key={i} style={{
          background: 'var(--chk-card)', border: '1px solid var(--chk-border)',
          borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10, fontSize: 18,
            background: `${m.color}22`, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>{m.icon}</div>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--chk-white)', lineHeight: 1 }}>{m.val}</div>
            <div style={{ fontSize: 11, color: 'var(--chk-muted)', marginTop: 3 }}>{m.lbl}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
